<template>
  <div style="font-size: 14px !important; border: 1px solid #E0E0E0;border-radius: 8px;padding:12px 18px; font-weight: 400 !important;">
    <div style="grid-template-columns: repeat(12, minmax(0, 1fr));display: grid; gap: 13px;">
      <div style="grid-column: span 3 / span 3;">
        <span class="font-weight-bold">Ngày chuyển: {{ transferFeeDetail.createdAt ? moment(transferFeeDetail.createdAt).format('DD-MM-YYYY') : '' }}</span>
      </div>
      <div class="font-weight-bold" style="grid-column: span 3 / span 3;text-align: center;">
        Loại :
        <span style="color: #F56C22; font-weight: 500;">
           {{transferFeeDetail && transferFeeDetail.type ? checkEmptyData(transferFeeDetail.type.name) : '' }}
         </span>
      </div>
      <div  style="grid-column: span 3 / span 3;text-align: center">
        <span>Mã ticket:
              <span class="font-weight-medium" v-on="on" v-bind="attrs" style=" color: blue; cursor: pointer">{{ checkEmptyData(transferFeeDetail.code) }}</span>
        </span>
      </div>
      <div style="grid-column: span 3 / span 3; text-align: right">
        <span class="font-weight-bold">Người thực hiện: {{transferFeeDetail.createdBy ? checkEmptyData(transferFeeDetail.createdBy.name) : '' }}</span>
      </div>
    </div>

    <div style="grid-template-columns: repeat(13, minmax(0, 1fr));display: grid; gap: 13px;" class="mt-5">
      <div style="grid-column: span 6 / span 6;">
        <div class="package-section">
          <div class="font-weight-bold mb-1 text-center">GÓI CŨ</div>
          <div style="font-style: italic;" class=" mb-1">Số tiền cọc còn lại chưa quy đổi: {{  transferFeeDetail.unusedReceiptAmount ? formatCurrencyNoD_C(transferFeeDetail.unusedReceiptAmount) : 0 }} đ</div>
          <div style="font-weight: 500" class="mb-3"> Sản phẩm chuyển: </div>
          <div v-if="transferFeeDetail.oldOrderProducts && transferFeeDetail.oldOrderProducts.length > 0">
            <div v-for="(product, index) in transferFeeDetail.oldOrderProducts" :key="'product' + index" class="mt-3">
              <div class="d-flex" style="font-weight: 500;column-gap: 10px;align-items: center">
                <v-icon class="pr-1" color="green">
                  mdi-book-open-variant
                </v-icon>
                <div style="width: calc(100% - 40px)">
                  <div class="d-flex" style="column-gap: 8px; align-items: center">
                    <div class="mb-1" style="margin-top: 2px">
                      {{ product.name }}
                    </div>
                    <div
                        v-if="product.productType === 'sku_combo' && transferFeeDetail.ticketType && transferFeeDetail.ticketType.id == 2"
                        style="color: #0575ff; cursor: pointer;width: 120px !important;"
                        class="d-flex"
                        @click="viewDetailCombo(product)"

                    >
                      <v-icon class="mx-1" style="color: #0575ff">mdi-information</v-icon
                      ><span class="my-auto" style="font-size: 11px !important;">Chi tiết combo</span>
                    </div>
                  </div>
                  <div class="mt-1 bg-content1" style="font-style: italic; font-size: 13px">
                    <template v-if="product.productType !== 'sku_combo'">
                      <template v-if="product.numberLessonTransfer !== null">
                        Số <span v-if="product.productType === 'sku_tutor'">buổi</span> <span v-else>tháng</span> chuyển :
                        {{ product.numberLessonTransfer ? product.numberLessonTransfer : '--' }}
                        <span v-if="product.productType === 'sku_tutor'">buổi</span> <span v-else>tháng</span>
                      </template>
                      <span v-if="transferFeeDetail.ticketType && transferFeeDetail.ticketType.id == 2">
                      - Số tiền: {{ product.priceType === 2 ? (product.intoMoney ? formatCurrencyNoD_C(product.intoMoney) : '--')
                          : (product.intoMoneyDeposit ? formatCurrencyNoD_C(product.intoMoneyDeposit) : '--') }} đ
                    </span>
                    </template>
                    <template v-else>
                      <template v-if="transferFeeDetail.ticketType && transferFeeDetail.ticketType.id === 2">
                        <span>
                          - Số tiền: {{ product.priceType === 2 ? (product.intoMoney ? formatCurrencyNoD_C(product.intoMoney) : '--')
                            : (product.intoMoneyDeposit ? formatCurrencyNoD_C(product.intoMoneyDeposit) : '--') }} đ
                        </span>
                      </template>
                      <template v-else>--</template>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-6">
            Đơn gốc : <span  style="cursor:pointer; color: blue; margin-left: 4px;" class="font-weight-bold">
            {{ transferFeeDetail.originOrderCode ? checkEmptyData(transferFeeDetail.originOrderCode) : '-' }}
          </span>
          </div>
        </div>
      </div>

      <div style="grid-column: span 1 / span 1;" class="d-flex align-center justify-center position-relative">
        <div class="transfer-divider">
          <div class="circle-arrow">
            <v-icon color="white" size="22">mdi-arrow-right</v-icon>
          </div>
          <div class="dashed-line"></div>
        </div>
      </div>

      <div style="grid-column: span 6 / span 6;">
        <div class="package-section">
          <div class="font-weight-bold mb-1 text-center">GÓI MỚI</div>
          <template v-if="transferFeeDetail.ticketType && transferFeeDetail.ticketType.id === 1">
            <div style="font-weight: 500" class="mb-3">Gói nhận phí :</div>
            <div class="mb-3" style="column-gap: 6px;">
              <div v-if="transferFeeDetail.newOrderProducts && transferFeeDetail.newOrderProducts.length > 0" >
                <div v-for="(product, index) in transferFeeDetail.newOrderProducts" :key="'product' + index" class="mt-3">
                  <div class="d-flex" style="font-weight: 500;column-gap: 10px;align-items: flex-start">
                    <v-icon class="pr-1" color="green">
                      mdi-book-open-variant
                    </v-icon>
                    <div style="width: calc(100% - 40px)">
                      <div class="mb-1" style="margin-top: 2px">
                        {{ product.name }}
                      </div>
                      <div class="d-flex align-center justify-space-between mt-1 bg-content1 " style="column-gap: 8px;font-style: italic; font-size: 13px">
                        <div>
                          Con:   {{product.customerName ? checkEmptyData(product.customerName) : ''}}
                          - UID: {{product.uid ? checkEmptyData(product.uid ) : '-' }}
                          - SID: {{product.sid ? checkEmptyData(product.sid ) : '-' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-3 d-flex" v-if="transferFeeDetail && transferFeeDetail.newOrderCodes && transferFeeDetail.newOrderCodes.length > 0">
              Đơn chuyển đổi:
              <span v-for="(order, index) in transferFeeDetail.newOrderCodes"  :key="index"
                    @click="openDetailOrder(order)"
                    style="cursor:pointer; color: blue; margin-left: 4px;" class="font-weight-bold">
                {{ order }}<span v-if="transferFeeDetail.newOrderCodes.length - 1  !== index">, </span>
            </span>
            </div>
          </template>
          <template v-else>
            <div style="font-weight: 500" class="mb-3">
              Mã biên nhận:
              {{ transferFeeDetail.paymentReceiptCode ? checkEmptyData(transferFeeDetail.paymentReceiptCode) : '--' }}
            </div>
            <div class="d-flex" style="font-weight: 500;column-gap: 10px;align-items: flex-start">
              <v-icon class="pr-1" color="green">
                mdi-book-open-variant
              </v-icon>
              <div style="width: calc(100% - 40px)">
                <div class="mb-1" style="margin-top: -2px">
                  Số tiền: {{ transferFeeDetail.amount ? formatCurrencyNoD_C(transferFeeDetail.amount) : '-' }} đ
                </div>
              </div>
            </div>
            <div class="mt-3 d-flex" v-if="transferFeeDetail && transferFeeDetail.newOrderCodes && transferFeeDetail.newOrderCodes.length > 0">
              Đơn chuyển đổi:
              <span v-for="(order, index) in transferFeeDetail.newOrderCodes"  :key="index"
                    @click="openDetailOrder(order)"
                    style="cursor:pointer; color: blue; margin-left: 4px;" class="font-weight-bold">
                {{ order }}<span v-if="transferFeeDetail.newOrderCodes.length - 1  !== index">, </span>
            </span>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: 'HistoryReceiptProduct',
  props: {
    urlERP: {
      type: String,
      default: process.env.VUE_APP_SORT_CLASS,
    },
    urlOMS: {
      type: String,
      default: process.env.VUE_APP_API_OMS,
    },
    urlCRM: {
      type: String,
      default: process.env.VUE_APP_API_ERP,
    },
    transferFeeDetail: {
      default: () => {},
    },
    isConfirm: {
      default: true,
    },
  },
  data() {
    return {
      moment,
      isShowDetailTransferFee: false,
    };
  },
  methods: {
    viewDetailCombo(id) {
      this.$emit("viewDetailCombo", id);
    },
    formatCurrencyNoD_C(val) {
      const cv = parseInt(val);
      const res =
          cv.toLocaleString("it-IT", { style: "currency", currency: "VND" }) || "";
      return res.slice(0, -3);
    },
    openDetailOrder(orderCode) {
      console.log(orderCode);
      // const orderId = orderCode ? orderCode.replace(/\D/g, '') : null;
      // if(orderId) {
      //   const routeData = `${process.env.VUE_APP_URL_CRM}/order-detail/${orderId}?orderList=true`
      //   window.open(routeData, '_blank');
      // }
    },
    checkEmptyData(data) {
      return data != null || data !== '' ? data : '';
    },
  },
};
</script>

<style scoped>
.ticket-card {
  border-radius: 12px !important;
}

.package-section {
  height: 100%;
  position: relative;
}

.transfer-divider {
  position: relative;
  height: 100%;
}

.circle-arrow {
  width: 28px;
  height: 28px;
  background-color: #6F44FF;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
}

.dashed-line {
  position: absolute;
  left: 46%;
  top: 31px;
  bottom: 0;
  border-left: 1px dashed #6F44FF;
  z-index: 1;
}

strong {
  font-weight: 600;
  color: #333;
}
.content-tooltip-transfer {
  box-shadow: 4px 4px 4px 0 rgba(102, 102, 102, 0.25);
  background: #fff !important;
}
.bg-content1 {
  background: #F7F7F7;
  border-radius: 4px;
  padding: 4px 16px;
  width: 100% !important;
  border: 1px solid #DEDEDE;
  font-style: italic;
  font-size: 13px;
}
</style>
